import React from "react";
import { CheckCircle2, AlertCircle, HelpCircle } from "lucide-react";

const halalMap = {
  confirmed: { label: "Halal disahkan", icon: <CheckCircle2 className="w-3 h-3" />, cls: "bg-green-50 text-green-700 border-green-200" },
  need_verify: { label: "Status halal perlu disemak", icon: <AlertCircle className="w-3 h-3" />, cls: "bg-amber-50 text-amber-700 border-amber-200" },
  unknown: { label: "Halal tidak dipastikan", icon: <HelpCircle className="w-3 h-3" />, cls: "bg-gray-50 text-gray-600 border-gray-200" },
};

export default function RestaurantCard({ r }) {
  const h = halalMap[r.halal_status] || halalMap.unknown;
  return (
    <div className="bg-white rounded-[1.5rem] p-4 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-[#E8E8ED]" data-testid="restaurant-card">
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-semibold text-[#0A2540]">{r.name}</div>
          {r.cuisine && <div className="text-xs text-gray-500">{r.cuisine}</div>}
        </div>
        <div className="text-sm font-medium text-[#0A2540]">RM{Number(r.price_myr || 0).toLocaleString()}</div>
      </div>
      <div className={`mt-2 inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full border ${h.cls}`}>
        {h.icon} {h.label}
      </div>
      {r.note && <div className="text-xs text-gray-500 mt-2">{r.note}</div>}
    </div>
  );
}
